import { isNativeTool } from './native-tools';
import { FlattenedJsonResult } from './FlattenedJsonResult';
import type { ToolResultRenderer } from './types';
import {
  AckResult,
  AgentListResult,
  BashResult,
  CognitiveSpawnResult,
  DiffResult,
  DocsReadResult,
  DocsSearchResult,
  FileContentResult,
  FileListResult,
  FileMetaResult,
  GrepResult,
  JsonEnvelopeResult,
  PinListResult,
  PlatformCallResult,
  ResultSearchResult,
  SearchHitsResult,
  WorkItemResult,
} from './shapes';

const NATIVE_RENDERERS: Record<string, ToolResultRenderer> = {
  docs_search: DocsSearchResult,
  docs_read: DocsReadResult,
  search: SearchHitsResult,
  context_search: SearchHitsResult,
  grep: GrepResult,
  file_read: FileContentResult,
  result_read: FileContentResult,
  file_list: FileListResult,
  cloud_list_versions: FileListResult,
  file_info: FileMetaResult,
  cloud_view_unsaved: FileMetaResult,
  file_write: AckResult,
  file_edit: DiffResult,
  file_append: AckResult,
  file_delete: AckResult,
  file_move: AckResult,
  cloud_save_version: AckResult,
  cloud_restore_version: AckResult,
  context_pin: AckResult,
  context_unpin: AckResult,
  assign_ticket: AckResult,
  add_comment: AckResult,
  transition_state: AckResult,
  list_teams: WorkItemResult,
  board_view: WorkItemResult,
  list_tickets: WorkItemResult,
  get_ticket: WorkItemResult,
  create_ticket: WorkItemResult,
  context_list: PinListResult,
  result_search: ResultSearchResult,
  workspace_init: JsonEnvelopeResult,
  skill_list: JsonEnvelopeResult,
  skill_search: JsonEnvelopeResult,
  skill_read: JsonEnvelopeResult,
  model_default: JsonEnvelopeResult,
  provider_list: JsonEnvelopeResult,
  model_list: JsonEnvelopeResult,
  process_list: JsonEnvelopeResult,
  platform_call: PlatformCallResult,
  explore: CognitiveSpawnResult,
  research: CognitiveSpawnResult,
  plan: CognitiveSpawnResult,
  evaluate: CognitiveSpawnResult,
  audit: CognitiveSpawnResult,
  delegate: CognitiveSpawnResult,
  execute_plan: CognitiveSpawnResult,
  triage: CognitiveSpawnResult,
  list_agents: AgentListResult,
  bash: BashResult,
};

export function getToolResultRenderer(toolName: string): ToolResultRenderer {
  if (isNativeTool(toolName)) {
    return NATIVE_RENDERERS[toolName] ?? FlattenedJsonResult;
  }
  return FlattenedJsonResult;
}
